// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__Lnknl","modal-block":"Modal_modal-block__Pu+Zh","backdrop":"Modal_backdrop__agCHd","modal":"Modal_modal__1Xv6J","close-btn":"Modal_close-btn__eZrYN"};